<template>
  <div>

    <v-dialog
    v-model="error"
    width="500"
    >

      <v-card>
        <v-card-title
          class="headline red accent-3"
          primary-title
        >
          Warning Message
        </v-card-title>

        <v-card-text>
          {{errorMsg}}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red accent-3"
            flat
            @click="setErrorZero"
          >
            close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <v-toolbar flat color="white">
      <v-toolbar-title>Monthly Income</v-toolbar-title>
     <v-spacer></v-spacer>
       <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        align="center"
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-dialog v-model="dialog" max-width="500px">
        <template v-slot:activator="{ on }">
          <v-btn color="primary" dark class="mb-2" v-on="on">Create</v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-form ref="form" v-model="valid" lazy-validation>
                <v-container grid-list-md>
                    <v-layout wrap>
                        <v-flex xs12 sm6 md6>
                        <v-text-field 
                        v-model="editedItem.title" 
                        label="Amount Range"
                        placeholder="20,000-50,000"
                        :rules="amountTitle"
                        ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                        <v-text-field 
                        v-model="editedItem.avg_amount" 
                        label="Avg Amount"
                        placeholder="i,e.4500"
                        :rules="avAmount"
                        ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md2>
                        <v-text-field 
                        v-model="editedItem.active" 
                        placeholder="0/1" 
                        label="Active status"
                        :rules="activeStatus"
                        ></v-text-field>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-form>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
            <v-btn color="blue darken-1" flat @click="save">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="indexData.monthlyIncome"
      :search="search"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td class="text-xs-center">{{ props.item.id }}</td>
        <td class="text-xs-center">{{ props.item.created_by }}</td>
        <td class="text-xs-center">{{ props.item.title }}</td>
        <td class="text-xs-center">{{ props.item.avg_amount }}</td>
        <td class="text-xs-center">{{ props.item.active }}</td>
        <td class="justify-center layout px-1">
          <v-icon
            small
            class="mr-5"
            @click="editItem(props.item)"
          >
            edit
          </v-icon>
          <v-icon
            small
            @click="deleteItem(props.item)"
          >
            delete
          </v-icon>
        </td>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'

 export default {
    data: () => ({
      dialog: false,
      search: '',
      apiUrl: 'monthly-income',
      headers: [
        {
          text: 'ID',
          align: 'center',
          sortable: false,
          value: 'id'
        },
        {
          text: 'Created By',
          align: 'center',
          sortable: false,
          value: 'created_by'
        },
        {
          text: 'Amount List(Tk)',
          align: 'center',
          sortable: false,
          value: 'title'
        },
        {
          text: 'Avg Amount(Tk)',
          align: 'center',
          sortable: false,
          value: 'avg_amount'
        },
        {
          text: 'Active Status',
          align: 'center',
          sortable: false,
          value: 'active'
        },
        { text: 'Actions', align:'center',value: 'actions' },
      ],
      editedIndex: -1,
      editedItem: {
        id:'',
        title:'',
        avg_amount:'',
        active:''
      },
      defaultItem: {
        id:'',
        title:'',
        avg_amount:'',
        active:''
      },
      valid: true,
      amountTitle: [(v) => !!v || "This field is required"],
      activeStatus: [(v) => !!v || "This field is required"],
      avAmount: [(v) => !!v || "This field is required"],
    }),

    computed: {
      ...mapGetters(['isLoggedIn', 'indexData', 'error', 'statusCode', 'errorMsg']),
      formTitle () {
        return this.editedIndex === -1 ? 'Crete New' : 'Edit'
      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      }
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        this.$store.dispatch('setIndexData', [this.apiUrl])
      },

      setErrorZero () {
        this.$store.dispatch('setErrorZero')
      },

      editItem (item) {
        this.editedIndex = this.indexData.monthlyIncome.indexOf(item)
        this.editedItem.id = item.id
        this.editedItem.title = item.title
        this.editedItem.avg_amount = item.avg_amount
        this.editedItem.active = item.active
        this.dialog = true
      },

      deleteItem (item) {
        const index = this.indexData.monthlyIncome.indexOf(item)
        confirm('Are you sure you want to delete this item?') && this.indexData.monthlyIncome.splice(index, 1)
        this.$store.dispatch('delete', [this.apiUrl, item.id])
      },

      close () {
        this.dialog = false
        this.initialize()
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        if (this.$refs.form.validate()) {
          if (this.editedIndex > -1) {
          this.$store.dispatch('store', [this.apiUrl, this.editedItem])
          } else {
          this.$store.dispatch('store', [this.apiUrl, this.editedItem]) 
          }
          this.close()  
        }  
      }
    }
  }
</script>